// extracted by mini-css-extract-plugin
export default {"innerContainer":"ImageModal_innerContainer__nn6lB","sideImage":"ImageModal_sideImage__VtUDl","mainImage":"ImageModal_mainImage__B2PMj"};